// @ts-nocheck
// 城市区域
import areaRequest from '@/utils/request';
// import store from '@/store/index.js';
const reFix = 'productadmin';
const product = 'product';

// 获取目录树
export function getPageTreeApi() {
  return areaRequest({
    url: reFix + '/Area/Index',
  });
}

// 获取单个对象数据
export function getOneObjApi(id) {
  return areaRequest({
    url: reFix + `/Area/${id}`,
  });
}

// 获取单个对象数据
export function getAreaList({ pAreaId, pageSize = 10, pageIndex = 1 }) {
  return areaRequest({
    url: reFix + '/Area/Get',
    params: {
      pAreaId,
      pageIndex,
      pageSize,
    },
  });
}
// 获取城市列表
export function getAreaListApi(params = {}) {
  return areaRequest({
    url: product + '/Area',
    params,
  });
}
// 获取楼盘
export function getHouseByAreaApi(params) {
  return areaRequest({
    url: product + '/House/area/' + params.areaId,
  });
}

// 新增表单
export function addFormApi(data) {
  return areaRequest({
    url: reFix + '/Area/Post',
    method: 'POST',
    data: { ...data },
  });
}

// 编辑表单
export function editFormApi(id, data) {
  return areaRequest({
    url: reFix + `/Area/${id}`,
    method: 'PUT',
    data: { ...data },
  });
}

// 删除表单
export function removeFormApi(data) {
  return areaRequest({
    url: reFix + '/Area',
    method: 'DELETE',
    data,
  });
}

// 获取城市对象数据
export function getCityList() {
  return areaRequest({
    url: reFix + `/Area/city`,
  });
}

// 分页获取某楼盘动态数据列表
export function getHouseNewsList(params) {
  // console.log('areaObj', areaObj);
  return areaRequest({
    url: reFix + `/House/news`,
    method: 'GET',
    params: { ...params },
  });
}

//获取单个动态数据
export function getHouseNewsApi(newsId) {
  return areaRequest({
    url: reFix + `/House/news/${newsId}`,
    // params: {
    //   newsId,
    // },
  });
}

//新增某楼盘动态数据
export function addHouseNewsApi(data) {
  return areaRequest({
    url: reFix + `/House/news`,
    method: 'POST',
    data: { ...data },
  });
}

//更新某楼盘动态数据
export function editHouseNewsApi(id, data) {
  return areaRequest({
    url: reFix + `/House/news/${id}`,
    method: 'PUT',
    data: { ...data },
  });
}

//删除某楼盘动态数据
export function removeHouseNewsApi(data) {
  return areaRequest({
    url: reFix + `/House/news`,
    method: 'DELETE',
    data,
  });
}

//关闭/开启楼盘动态状态
export function HouseNewsStatusApi(data, type) {
  return areaRequest({
    url: reFix + `/House/news/` + type,
    method: 'PUT',
    data,
  });
}

//开启楼盘动态状态
export function openHouseNewsLApi() {
  return areaRequest({
    url: reFix + `/House/news/open`,
    method: 'PUT',
  });
}

//上传动态图片
export function houseNewsUpload(data) {
  return areaRequest({
    url: 'upload/Images/upload',
    method: 'POST',
    data: { ...data },
  });
}

// 城市修改排序
// 请求URL:  /productadmin/Area/updateSort
// 请求参数：areaId,  sortIndex
// 请求方法：PUT
// 编辑排序
export function editSortApi(params) {
  return areaRequest({
    url: reFix + `/Area/updateSort`,
    method: 'PUT',
    params,
  });
}
